import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../views/SignIn.vue";
import Projects from "../views/Projects.vue";
import Project from "../views/Project.vue";
import AdmProject from "../views/AdmProject.vue";

import store from "@/store/";
//import NewProject from "../views/NewProject.vue";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/",
			redirect: "/projects",
		},
		{
			path: "/sign-in",
			name: "SignIn",
			meta: {
				layout: "SignIn",
			},
			component: SignIn,
		},
		{
			path: "/projects",
			name: "Projects",
			component: Projects,
			meta: {
				layout: "SignIn",
				requiresAuth: true,
				requiresAdmin: false,
			},
		},
		{
			path: "/project/:user/:id/:status",
			name: "NewProject",
			props: true,
			component: Project,
			meta: {
				requiresAuth: true,
				requiresAdmin: false,
			},
		},
		{
			path: "/project/a/:user/:id/:status",
			name: "NewAdmProject",
			props: true,
			component: AdmProject,
			meta: {
				layout: "Default",
				requiresAuth: true,
				requiresAdmin: true,
			},
		},
		{
			path: "*",
			name: "404",
		},
	],
});

router.beforeEach((to, from, next) => {
	//check to see if user is not logged in
	//const userData = JSON.parse(localStorage.getItem("user"));

	const loggedIn = localStorage.getItem("user");
	if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
		next("/sign-in");
	} else {
		next();
	}

	//check to see if user is admin

	const isAdmin = store.getters["user/userAdminStatus"];
	if (to.matched.some((record) => record.meta.requiresAdmin) && !isAdmin) {
		alert("NOT ADMIN");
		next("/sign-in");
	} else {
		next();
	}
});

export default router;
